<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { brandActiveFilters } from '../../brand/store/brand_store';

  export let chipName;
  const dispatcher = createEventDispatcher();
  let clicked: boolean = false;

  function filterChipClicked(chipName) {
    if (!$brandActiveFilters.includes(chipName)) {
      brandActiveFilters.update(x => {
        x = [...$brandActiveFilters, chipName];
        return x;
      });
    } else {
      $brandActiveFilters = $brandActiveFilters.filter(item => item !== chipName);
    }
    clicked = !clicked;
    dispatcher('filterChipClicked', { chipName, clicked });
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
  class="filter-chip-button"
  class:selected={$brandActiveFilters.includes(chipName)}
  on:click={() => filterChipClicked(chipName)}
>
  {@html chipName}
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .filter-chip-button {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $secondary-gray-02;
    color: $neutral-dark-01;
    border-radius: 100px;
    padding: 12px;
    gap: 12px;
    min-height: 42px;
    width: fit-content;
    cursor: pointer;
    white-space: nowrap;
  }
  .selected {
    background: $neutral-dark-01;
    color: $primary-white;
  }
</style>
